import AppGlobalsMixin from "@/helpers/mixins/AppGlobalsMixin";

export function registerAppGlobals(target) {
  if (!target || typeof target.mixin !== "function") {
    throw new Error("App globals require a target with a mixin method.");
  }

  target.mixin(AppGlobalsMixin);
  return target;
}
